/**
 * Concrete-handprint silhouette. Two stylised palm + finger impressions
 * pressed into the surface — the visual signature of the Mann's Chinese
 * Theatre forecourt where stars from Pickford to Pitt have left their marks.
 * Used as a watermark on Forecourt plaques.
 */
export function Handprint({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      viewBox="0 0 240 200"
      className={className}
      role="presentation"
      aria-hidden="true"
    >
      <g fill="rgba(15,6,6,0.18)">
        {/* Right hand */}
        <g transform="translate(130, 20)">
          {/* Palm */}
          <ellipse cx="40" cy="100" rx="38" ry="36" />
          {/* Thumb */}
          <ellipse cx="6" cy="84" rx="11" ry="20" transform="rotate(-30 6 84)" />
          {/* Index */}
          <ellipse cx="20" cy="40" rx="9" ry="32" transform="rotate(-12 20 40)" />
          {/* Middle */}
          <ellipse cx="38" cy="28" rx="9" ry="38" />
          {/* Ring */}
          <ellipse cx="56" cy="32" rx="9" ry="36" transform="rotate(8 56 32)" />
          {/* Pinky */}
          <ellipse cx="72" cy="48" rx="8" ry="28" transform="rotate(16 72 48)" />
        </g>
        {/* Left hand (mirrored) */}
        <g transform="translate(70, 20) scale(-1, 1)">
          <ellipse cx="40" cy="100" rx="38" ry="36" />
          <ellipse cx="6" cy="84" rx="11" ry="20" transform="rotate(-30 6 84)" />
          <ellipse cx="20" cy="40" rx="9" ry="32" transform="rotate(-12 20 40)" />
          <ellipse cx="38" cy="28" rx="9" ry="38" />
          <ellipse cx="56" cy="32" rx="9" ry="36" transform="rotate(8 56 32)" />
          <ellipse cx="72" cy="48" rx="8" ry="28" transform="rotate(16 72 48)" />
        </g>
      </g>
    </svg>
  );
}
